import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.AUTH].REGISTER_USER]: {
		url: '/registration/register/',
		requestOptions: {
			method: 'POST'
		},
	},

	[ModulesConfigMap[ModulesMap.AUTH].LOGIN_USER]: {
		url: '/auth/token/',
		requestOptions: {
			method: 'POST'
		},
	},

	[ModulesConfigMap[ModulesMap.AUTH].RESEND_EMAIL_CONFIRMATION]: {
		url: '/users/v1/send_confirmation/:id/', // FIXME: fix url
	},
}
